import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import "./VideoSection.css"; // Your CSS file
import video1 from '../Components/Images/video3.mp4'
import video2 from '../Components/videos/Aivideo.mp4'

const VideoSection = () => {
  const navigate=useNavigate();
  const handleclick=()=>{
    navigate('/services');
    window.scrollTo(0, 0);

  }

  const handleclickone=()=>{
    navigate('/contact-us');
    window.scrollTo(0, 0);
  }
 
  return (
    <section className="w3l-video" id="video">
      <div className="video-overlay"></div>
      <div className="video-mid-w3 py-5">
        <Container>
          <Row className="align-items-center">
            {/* Left Column - Text Content */}
            <Col lg={6} className="mb-5 mb-lg-0 pe-lg-3 text-white">
              <div className="title-content text-left">
                <h6 className="title-subhny mb-2">Time to grow</h6>
                <h3 className="title-w3l two">Make better ideas happen fast</h3>
              </div>
              <p className="mt-md-4 mt-3">
              From retail security to industrial printing and POS systems — Sensetech Trading LLC delivers cutting-edge technology for every business need. Reliable support, fast delivery, and trusted service across Dubai.
              </p>
              <div className="w3l-two-buttons mt-4">
                <button  className="me-2" onClick={handleclick} style={{fontFamily:"Poppins", backgroundColor:"#3ec63e"}}>Explore Products</button>
                <button variant="outline-light" onClick={handleclickone} style={{fontFamily:"Poppins"}}>Get a Free Quote</button>
              </div>
            </Col>

            {/* Right Column - Video */}
            <Col lg={6} className="ps-lg-5">
                          {/* <div className="video-container position-relative">
                            <div className="play-button-wrapper">
                              <a href={video2} className="popup-with-zoom-anim play-view">
                                <span className="video-play-icon">
                                  <span className="fa fa-play"></span>
                                </span>
                              </a>
                            </div>
                          </div> */}
                          <div className="">
                            <video width="100%" controls>
                              <source src={video2} type="video/mp4" />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default VideoSection;